import axios from 'axios'
import { TRANSMITIR_EMISSAO_MDFE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function transmitirEmissaoMdfe(emissaoMdfeId, empresaId) {
  const url = `${URL}/emissao-mdfe/${emissaoMdfeId}/empresa/${empresaId}/transmitir-mdfe`;
  return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: TRANSMITIR_EMISSAO_MDFE,
        payload: response
      })
  );
}
